(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/animations/position.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/animations/position.js');
"use strict";

const positions = {
  outsideLeft: '-100%',
  outsideRight: '200%',
  center: '0%'
};
setGlobal('svs.components.onboarding.slides.animations.positions', positions);

 })(window);